export default '4.23.0-experimental-typescript.0';
